import React, {useState, useEffect} from 'react'

import './Table.scss'

import Axios from 'axios';

import { useSelector } from 'react-redux';

import { setAlert } from '../../../redux/actions/alertActions';

import { connect } from 'react-redux'

import { hostDetect } from '../../../config/envConfig';

import Pagination_api from './Pagination_api/Pagination_api';

import StatusController from './StatusController/StatusController';

import { Settings, Trash2 } from 'react-feather';

import { Link } from 'react-router-dom';

import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css';

// moment js
import moment from 'moment'
import 'moment/locale/ru'
moment.locale('ru')

const Table = ({setAlert}) => {

    const site_id = useSelector(state => state.siteInfo.site.id);

    const [pushList, setPushList] = useState([]);
    const [pushLength, setPushLength] = useState(0);

    const [apiLoading, setApiLoading] = useState(false);
    
    // pagination
    const [paginationCurrent, setPaginationCurrent] = useState(1);
    const [paginationLimit, setPaginationLimit] = useState(10);

    // delete
    const [deletingId, setDeletingId] = useState(null);

    // filter
    const [cellFilter, setCellFilter] = useState({column: null, order: null})

    // dates
    const [campDates, setCampDates] = useState({
        start : moment().startOf('month').format('YYYY-MM-DD'),
        end : moment().format('YYYY-MM-DD')
    })

    useEffect(()=>{
        // reset pagination
        setPaginationCurrent(1)

        getPushApi(0, paginationLimit)
    },[site_id, cellFilter.order, cellFilter.column, campDates.start, campDates.end])

    const getPushApi = (start, limit) => {

        setApiLoading(true)

        Axios.get(`${hostDetect('api')}/push-publisher-ad/get-list?site_id=${site_id}&date_from=${campDates.start}&date_to=${campDates.end}&start=${start}&limit=${limit}${cellFilter.order ? '&order='+cellFilter.order : ''}${cellFilter.column ? '&column='+cellFilter.column : ''}`, {withCredentials: true})
		    .then(response => {
			    const success = response.data.success;

                setApiLoading(false)

			    if(success){
                    setPushLength(response.data.data.count)
                    setPushList(response.data.data.entries)
			    } else {
				    let errMessage = response.data.data.message;
                    setAlert('error', errMessage);
			    }
		    })
		    .catch(err => {
                setApiLoading(false)
			    setAlert('error', 'Не получилось отправить запрос!');
		    })
    }

    const handlePageClick = (page) => {
        let newStart = (page - 1) * paginationLimit
        setPaginationCurrent(page)
        getPushApi(newStart, paginationLimit)
    }
    
    const handlePaginationSelect = (value) => {
        setPaginationLimit(value)
        setPaginationCurrent(1)
        getPushApi(0, value)
    }

    const updateAdsList = (id, status) => {
        setPushList(prev => {
			return prev.map(item => {
				if(item.id === id){
					item.status = status
				}
				return item
			})
		})
    }

    const formatNumbers = ( numbers ) => {
        return new Intl.NumberFormat().format(numbers)
    }
    
    const formatFixed = (value, fixLength) => {
        if(value) {
            let statNumber = String(value),
                dotPosition = statNumber.indexOf('.');
            if(dotPosition === -1){
                return statNumber + '.00';
            } else {
                let numberBeforeDot = statNumber.slice(0, dotPosition),
                    numberAfterDot = statNumber.slice(dotPosition+1);
    
                return numberBeforeDot + '.' + numberAfterDot.slice(0, fixLength);
            }
        } else {
          return '0'
        }
    }

    // delete click
    const setDeletePushMessage = (id) => {
        setDeletingId(id);
    }

    const deleteConfirm = () => {
        let formData = new FormData();
		formData.append('status', '100');

		let apiOptions = {
			withCredentials: true
		}

		Axios.post(`${hostDetect('api')}/push-ad/update-status/?id=${deletingId}`, formData, apiOptions)
			.then(response => {

				const success = response.data.success;

				if(success){
					updateAdsList(deletingId, '100')
                    setDeletingId(null)
					setAlert('success', 'Статус обновлен!');
				} else {
					let errMessage = response.data.data.message;
					setAlert('error', errMessage);
				}
			})
			.catch(err => {
				setAlert('error', 'Не получилось отправить запрос!');
			})
    }

    const deleteCancel = () => {
        setDeletingId(null)
    }

    // filter
    const setFilter = (column) => {
        const orderDefine = () => {
            if(cellFilter.order === null){
              return 'desc'
            }
            if(cellFilter.order === 'asc'){
              return 'desc'
            }
            if(cellFilter.order === 'desc'){
              return 'asc'
            }
        }

        setCellFilter({column, order: orderDefine()})
    }

    // daterange
    const handleCallback = (start, end) => {
        setCampDates({start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD')})
    };

    return(
        <div className="push-sending-table">
            <div className="push-sending-table__list">

                <div>
                    <div className="mb-2">
                        <small>Выберите период:</small>
                    </div>
                    <div className="push-sending-table__datepicker">
                        <DateRangePicker
                            initialSettings={
                                { 
                                    startDate: moment(campDates.start),
                                    endDate: moment(campDates.end),
                                    ranges: {
                                        'Сегодня': [moment(), moment()],
                                        'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                        'Последние 7 дней': [moment().subtract(6, 'days'), moment()],
                                        'Последние 30 дней': [moment().subtract(29, 'days'), moment()],
                                        'Последние 6 месяцев': [moment().subtract(6, 'month'), moment()],
                                        'Этот месяц': [moment().startOf('month'), moment().endOf('month')],
                                        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                    },
                                    locale: {
                                        'customRangeLabel': 'Выбор даты',
                                        "daysOfWeek": [
                                            "Вс",
                                            "Пн",
                                            "Вт",
                                            "Ср",
                                            "Чт",
                                            "Пт",
                                            "Сб"
                                        ],
                                        "monthNames": [
                                            "Январь",
                                            "Февраль",
                                            "Март",
                                            "Апрель",
                                            "Май",
                                            "Июнь",
                                            "Июль",
                                            "Август",
                                            "Сентябрь",
                                            "Октябрь",
                                            "Ноябрь",
                                            "Декабрь"
                                        ],
                                        "firstDay": 1,
                                        "applyLabel": "Применить",
                                        "cancelLabel": "Отмена",
                                    },
                                    buttonClasses: 'custom btn'
                                }
                            } onCallback={handleCallback}>
                            <input type="text" className="form-control" />
                        </DateRangePicker>
                    </div>
                </div>

                <table className="table table-theme table-row v-middle">
                    <thead>
                        <tr>
                            <th className="text-muted">Изображение</th>
                            <th className="text-muted">Уведомление</th>
                            <th className="text-muted">Статус</th>
                            <th className={`text-muted th-inner sortable left-caret ${cellFilter.column === 'views' ? cellFilter.order : ''}`} onClick={() => setFilter('views')}>Показы</th>
                            <th className={`text-muted th-inner sortable left-caret ${cellFilter.column === 'clicks' ? cellFilter.order : ''}`} onClick={() => setFilter('clicks')}>Клики</th>
                            <th className={`text-muted th-inner sortable left-caret ${cellFilter.column === 'spent' ? cellFilter.order : ''}`} onClick={() => setFilter('spent')}>Потрачено</th>
                            <th className="text-muted">CTR</th>
                            <th className="text-muted">CPC</th>
                            <th className="text-muted">CPM</th>
                            <th className="text-muted">Действия</th>
                        </tr>
                    </thead>
                    <tbody>

                    {
                        pushList.length ? (
                            pushList.map((item, i) => {
                                return (
                                    <tr className=" v-middle push-sending-table__row" key={item.id}>
                                        <td style={{width: "180px"}}>
                                            <div className="push-sending-table__image" style={{backgroundImage: `url(${item.image.trim()})`}}></div>
                                        </td>
                                        <td>
                                            <div className="push-sending-table__text" style={{maxWidth: "250px", minWidth: "180px"}}>
                                                <small className="text-fade h-1x">id: {item.id}</small>
                                                <div className="push-title">{item.title}</div>
                                                <div className="push-body">{item.body}</div>
                                                <a className="push-link" title={item.url}>{item.url}</a>
                                            </div>
                                        </td>
                                        <td>
                                            <span>
                                                <StatusController status={item.status} id={item.id} updateAdsList={updateAdsList} />
                                            </span>
                                        </td>
                                        {
                                            item.reason ? (
                                                <td colSpan={6}>
                                                    <span className="badge badge-light" style={{fontSize: 13}}>Причина отклонения:</span>
                                                    <br />
                                                    <strong className="d-block text-muted mt-2 mb-0 text-danger" style={{fontSize: 13}}>{ item.reason }</strong>
                                                </td>
                                            ) : (
                                                <>
                                                    {/* views */}
                                                    <td className="text-center">
                                                        <span className="item-amount text-muted text-sm ">{formatNumbers(Number(item.views))}</span>
                                                    </td>
                                                    {/* clicks */}
                                                    <td className="text-center">
                                                        <span className="item-amount text-muted text-sm ">{formatNumbers(Number(item.clicks))}</span>
                                                    </td>
                                                    {/* spent */}
                                                    <td className="no-wrap text-center">
                                                        <span className="item-amount text-muted text-sm ">{formatFixed(Number(item.spent), 1)} ₽</span>
                                                    </td>
                                                    {/* ctr */}
                                                    <td className="no-wrap text-center">
                                                        <span className="item-amount text-muted text-sm ">{formatFixed(Number(item.ctr), 1)} %</span>
                                                    </td>
                                                    {/* cpc */}
                                                    <td className="no-wrap text-center">
                                                        <span className="item-amount text-muted text-sm ">{formatFixed(Number(item.cpc), 1)} ₽</span>
                                                    </td>
                                                    {/* cpm */}
                                                    <td className="no-wrap text-center">
                                                        <span className="item-amount text-muted text-sm ">{formatFixed(Number(item.cpm), 1)}</span>
                                                    </td>
                                                </>
                                            )
                                        }
                                        
                                        <td>
                                            {
                                                item.status !== '100' ? (
                                                    <Link className="item-amount text-sm push-sending-table__body"  to={`/push-edit/${item.id}`} title="Настройки уведомления">
                                                        <Settings size={14} style={{marginRight: '10px'}} />
                                                    </Link>
                                                ) : null
                                            }
                                            {
                                                item.status === '100' ? 
                                                    null : 
                                                    <Trash2 
                                                        size={14} 
                                                        color={'#f54394'} 
                                                        style={{cursor: 'pointer'}} 
                                                        data-toggle="modal" 
                                                        data-target="#delete-push-message-modal" 
                                                        onClick={() => setDeletePushMessage(item.id)} 
                                                        title="Удалить уведомление" />
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr className=" v-middle">
                                <td colSpan="3">Статьи отсутствуют</td>
                            </tr>
                        )
                    }

                    </tbody>
                </table>

                {/* delete single delete-push-message-modal */}
                <div id="delete-push-message-modal" className="modal fade show" data-backdrop="true" aria-modal="true">
                    <div className="modal-dialog ">
                        <div className="modal-content ">
                            <div className="modal-header ">
                                <div className="modal-title text-md">Удалить push-уведомление</div>
                                <button className="close" data-dismiss="modal" onClick={deleteCancel}>×</button>
                            </div>
                            <div className="modal-body">
                                <p>Вы уверены, что хотите удалить push-уведомление - #{deletingId} ?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={deleteConfirm}>Да</button>
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={deleteCancel}>Нет</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* delete single delete-push-message-modal */}

            </div>

            {
                pushList.length ? (
                    <div className="push-sending-table__controls">

                        <div className="push-sending-table__controls-pagination">
                            <Pagination_api 
                                currentPage={paginationCurrent}
                                totalCount={pushLength}
                                pageSize={paginationLimit}
                                onPageChange={page => handlePageClick(page)} />
                        </div>
                        
                        <div className="push-sending-table__controls-limit">
                            <select className="form-control" value={paginationLimit} onChange={e => handlePaginationSelect(e.target.value)}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                            </select>
                        </div>
                    </div>
                    ) : null
            }


            {
                apiLoading ? <div className="loader-line"></div> : null
            }
        </div>
    )
}


const mapDispatchToProps = {
    setAlert
  }
  
export default connect(null, mapDispatchToProps)(Table)